import { AllFlagsDataFilters } from '@modules/HappinessModule/interfaces/AllFlagsDataFilters';
import { createAction } from '@reduxjs/toolkit';

export const getAllFlagsData = createAction<AllFlagsDataFilters>('allFlagsPage/getAllFlagsData');
export const getAllLocationsData = createAction('allFlagsPage/getAllLocationsData');
export const setInvolvedUsersIds = createAction<string[]>('allFlagsPage/setInvolvedUsersIds');
export const setFlagManagersIds = createAction<string[]>('allFlagsPage/setFlagManagersIds');
export const setFlagAuthorsIds = createAction<string[]>('allFlagsPage/setFlagAuthorsIds');
